import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/schedly/calcom/apps/web/modules/auth/forgot-password/forgot-password-view.tsx");
